
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TeeBox } from "@/types";
import { useIsMobile } from "@/hooks/use-mobile";

interface TeeBoxSelectorProps {
  value: TeeBox;
  onChange: (tee: TeeBox) => void;
  teeOptions?: TeeBox[];
}

export const TeeBoxSelector = ({ value, onChange, teeOptions = ["white", "blue", "black", "gold", "red"] }: TeeBoxSelectorProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-1">
      <Label htmlFor="tee" className={isMobile ? "text-xs" : ""}>Tee Box</Label>
      <Select value={value} onValueChange={(val) => onChange(val as TeeBox)}>
        <SelectTrigger id="tee" className={isMobile ? "h-8 text-xs" : ""}>
          <SelectValue placeholder="Select tee box" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {teeOptions.map((tee) => (
              <SelectItem key={tee} value={tee}>
                {tee.charAt(0).toUpperCase() + tee.slice(1)}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
